import { openDefaultAnimatedActionModal } from "shared/components/Modals/AnimatedPendingActionModal";
import { COMMON_PENDING_ANIMATION_MESSAGES } from "shared/config/constants";
import useModal from "shared/hooks/useModal";

import { sendDealToPMS } from "shared/lib/api/dealApi";
import { notifyError, notifySuccess } from "shared/utils/ui";

import { DealSummary } from "../types";

export const useHook = (deal: DealSummary, hide: () => void) => {
  const { closeActiveModalDialog } = useModal();

  const sendToPms = async () => {
    const messages = [...COMMON_PENDING_ANIMATION_MESSAGES, "Sent!"];

    hide();
    const animatedPendingActionApi = openDefaultAnimatedActionModal(messages);
    try {
      await sendDealToPMS({ id: deal?.id });
      animatedPendingActionApi.finishAnimation(() => {
        notifySuccess("Successfully sent the application to Entrata.");
      });
    } catch (err: any) {
      const { error } = err;
      closeActiveModalDialog();
      if (error) {
        notifyError(error);
      } else {
        notifyError("Failed to send the application to Entrata.");
      }
      throw err;
    }
  };
  return { sendToPms };
};
